export default {
  methods: {
    applyFilterCopy() {
      this.initLabels();
      this.currentValue = {...this.currentFilter};
    },
  },
};
